import { render, staticRenderFns } from "./closed_mails.vue?vue&type=template&id=0ff20e32"
import script from "./closed_mails.vue?vue&type=script&lang=js"
export * from "./closed_mails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports